import { IKnmInspector248 } from 'APIPackage/KnmModule/interfaces/IKnmInspector248';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IKnmErpErvkFormInspector } from 'KnmErpPackage/KnmErpKnoOrganizationModule/interfaces/IknmErpErvkFormInspector';

export function convertErpErvkFormInspectorToKnmInspector248(
  formInspector: IKnmErpErvkFormInspector,
): IKnmInspector248 {
  return {
    fullName: formInspector.fullName,
    guid: formInspector.position?.guid || null,
    dateCreate: null,
    position: formInspector.position?.value
      ? {
          dictId: formInspector.position.value.dictId as DictionaryUUIDsEnum,
          dictVersionId: formInspector.position.value.dictVersionId,
        }
      : null,
  };
}
